export class AnalyticsModel {

  id: number;
  userName: string;
  action: string;
  moreInfo: string;
  devise: string;
  mobile: boolean;
  onLine: boolean;
  language: string;
  browserName: string;
  majorVersion: string;
  osName: string;
  ip: string;
  userAgent: string;

  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}
